import { UserActionViewDetail } from "../catalog/functions/userAction/userActionViewDetails";
import { UserActionViewDetailIcon } from "../catalog/functions/userAction/userActionViewDetailsIcon";

export const USERACTIONVIEWDETAILS: UserActionViewDetail[] = [
    { id: 1, icon: UserActionViewDetailIcon.Wrench, hintLookupKey: "RemovePathFromMimeSourcelong", textLookupKey: "RemovePathFromMimeSourceShort", getCssClassForIcon: UserActionViewDetail.prototype.getCssClassForIcon },

];
